import React from 'react';
import { Form } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getCurrentUserEmail } from 'modules/users/selectors/currentUser';
import { Modal } from 'ui/base/index';
import EmailInput from 'ui/form/EmailInput';

/**
 * @typedef {{
 *   translationKey?: string,
 *   onCancel: () => void,
 *   onOk: (email: string) => void,
 *   warningMessage?: string,
 *   okButtonProps?: import('antd/lib/button').ButtonProps,
 * }} ExportModalProps
 */

/** @type {React.FC<ExportModalProps>} */
const ExportModal = ({ translationKey, onCancel, onOk, warningMessage, okButtonProps = {} }) => {
  const email = useSelector(getCurrentUserEmail);

  const onSubmit = values => onOk(values?.email);

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ email }}
      validateOnBlur={false} // form might become slower if a lot of fields
      subscription={{ valid: true }}
      render={({ valid, handleSubmit: submitForm }) => (
        <Modal
          open
          onOk={submitForm}
          onCancel={onCancel}
          okButtonProps={{ ...okButtonProps, disabled: !valid }}
          title={<FormattedMessage id={`${translationKey}.export_modal.title`} defaultMessage="Export data" />}
          okText={<FormattedMessage id="ok" defaultMessage="Ok" />}
        >
          <div data-cy="export-modal">
            <FormattedMessage
              id={`${translationKey}.export_modal.body`}
              defaultMessage="Data will be exported into Excel format. Please fill in your email address in order to receive the file. This operation may take a few minutes."
              tagName="p"
            />
            {warningMessage && (
              <p className="font-weight-bold">
                {warningMessage}
              </p>
            )}
            <EmailInput name="email" required />
          </div>
        </Modal>
      )}
    />
  );
};

export default ExportModal;
